import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
//  import { useTranslation } from "react-i18next";

type DisplayCouponsUsageTypesDropDownProps = {

    callbackFn?: any;
};


export const DisplayCouponsUsageTypesDropDown: React.FC<
    DisplayCouponsUsageTypesDropDownProps
> = ({ callbackFn }) => {
    const { t } = useTranslation();
    const couponTypes = [{
        name: t("coupons.usagetypes.firsttime"),
        code: 1
    },
    ]

    return (
        <>
            <SelectField
                name="usage_type"
                label={t("coupons.table.column.usage_type")}
                options={(couponTypes ?? []).map(
                    (couponType: any) => {
                        return {
                            label: couponType.name!,

                            value: couponType.code!,

                        };
                    }
                )}
                showSearch
                optionFilterProp="label"
                onChange={(value, couponType) => callbackFn(value, couponType)}
            />
        </>
    );
};
